// import { Award, Calendar, MapPin, Users } from "lucide-react";
// import React from "react";
// import AchievementUtilities from "../../utilitis/AchievementUtilities";

// const InterStateChampionship = () => {
//   const achievementData = {
//     title: "Inter-State Championship",
//     subtitle: "Fostering Excellence Through Friendly Competition",
//     description:
//       "Competitive events showcasing excellence in various academic and sports disciplines.",
//     images: [
//       "https://i.ibb.co/DwrxYXz/IMG-3355.jpg",
//       "https://i.ibb.co/RY0QSCX/IMG-20240530-WA0031-EATI-RUPENDRASRIVINAYGAR.webp",
//       "https://i.ibb.co/HYxLMg0/Whats-App-Image-2024-08-08-at-10-44-49-AM.webp",
//       "https://i.ibb.co/1Qty61K/a9cab410-561f-4192-93e4-ff7f38f9cf5a.webp",
//       "https://i.ibb.co/1Qty61K/a9cab410-561f-4192-93e4-ff7f38f9cf5a.webp",
//       "https://i.ibb.co/HYxLMg0/Whats-App-Image-2024-08-08-at-10-44-49-AM.webp",
//       "https://i.ibb.co/RY0QSCX/IMG-20240530-WA0031-EATI-RUPENDRASRIVINAYGAR.webp",
//       "https://i.ibb.co/2cr0t6D/Whats-App-Image-2024-08-08-at-10-43-56-AM.webp",
//     ],
//     iconTexts: [
//       { icon: Calendar, text: "Annual Tournament" },
//       { icon: MapPin, text: "Multiple Venues" },
//       { icon: Users, text: "500+ Participants" },
//       { icon: Award, text: "10+ Disciplines" },
//     ],
//     highlights: [
//       "Opening ceremony with torch relay and oath-taking",
//       "Academic competitions including debates, quizzes, and science fairs",
//       "Sports tournaments in athletics, swimming, and team sports",
//       "Cultural competitions showcasing regional diversity",
//       "Closing ceremony with awards distribution and cultural performances",
//     ],
//     upcomingEvents: [
//       {
//         title: "Chess Championship",
//         description: "Strategic battles on the 64 squares",
//         date: "November 5, 2024",
//       },
//       {
//         title: "Track and Field Events",
//         description: "Showcasing speed, strength, and endurance",
//         date: "November 7, 2024",
//       },
//       {
//         title: "Science Olympiad",
//         description: "Testing knowledge and innovation in sciences",
//         date: "November 9, 2024",
//       },
//     ],
//     galleryLink: "/gallery/inter-state-championship",
//   };

//   return <AchievementUtilities {...achievementData} />;
// };

// export default InterStateChampionship;

import { Award, Calendar, MapPin, Users } from "lucide-react";
import React from "react";
import AchievementReusableComponent from "../../utilitis/AchievementReusable";

const InterStateChampionship = () => {
  const achievementData = {
    title: "Inter-State Championship",
    subtitle: "Fostering Excellence Through Friendly Competition",
    description:
      "Competitive events showcasing excellence in various academic and sports disciplines.",
    images: [
      "https://i.ibb.co/DwrxYXz/IMG-3355.jpg",
      "https://i.ibb.co/RY0QSCX/IMG-20240530-WA0031-EATI-RUPENDRASRIVINAYGAR.webp",
      "https://i.ibb.co/HYxLMg0/Whats-App-Image-2024-08-08-at-10-44-49-AM.webp",
      "https://i.ibb.co/1Qty61K/a9cab410-561f-4192-93e4-ff7f38f9cf5a.webp",
    ],
    iconTexts: [
      { icon: Calendar, text: "Annual Tournament" },
      { icon: MapPin, text: "Multiple Venues" },
      { icon: Users, text: "500+ Participants" },
      { icon: Award, text: "10+ Disciplines" },
    ],
    highlights: [
      "Opening ceremony with torch relay and oath-taking",
      "Academic competitions including debates, quizzes, and science fairs",
      "Sports tournaments in athletics, swimming, and team sports",
      "Cultural competitions showcasing regional diversity",
      "Closing ceremony with awards distribution and cultural performances",
    ],
    upcomingEvents: [
      {
        title: "Chess Championship",
        description: "Strategic battles on the 64 squares",
        date: "November 5, 2024",
      },
      {
        title: "Track and Field Events",
        description: "Showcasing speed, strength, and endurance",
        date: "November 7, 2024",
      },
      {
        title: "Science Olympiad",
        description: "Testing knowledge and innovation in sciences",
        date: "November 9, 2024",
      },
    ],
    galleryLink: "/gallery",
  };

  return <AchievementReusableComponent {...achievementData} />;
};

export default InterStateChampionship;
